module.exports = __webpack_public_path__ + "static/liegesport-522e621d99fa9cdb1d606784aa5314f0.png";